import React, { useEffect, useState } from 'react';
import type { VideoFilter } from '../../services/video.service';

interface FilterProps {
  categories: VideoFilter[];
  teachers: string[];
  partners: VideoFilter[];
  equipment: VideoFilter[];
  selectedFilters: {
    search: string;
    category: string;
    teacher: string;
    partner: string;
    duration: string;
    equipment: string;
  };
  onFilterChange: (filters: {
    search: string;
    category: string;
    teacher: string;
    partner: string;
    duration: string;
    equipment: string;
  }) => void;
  onReset: () => void;
}

const Filters: React.FC<FilterProps> = ({
  categories,
  teachers,
  partners,
  equipment,
  selectedFilters,
  onFilterChange,
  onReset
}) => {
  const [searchInput, setSearchInput] = useState(selectedFilters.search);
  useEffect(() => {
    setSearchInput(selectedFilters.search);
  }, [selectedFilters.search]);
  const handleInputChange = (field: string, value: string) => {
    onFilterChange({
      ...selectedFilters,
      [field]: value
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchInput !== selectedFilters.search) {
        onFilterChange({
          ...selectedFilters,
          search: searchInput
        });
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchInput, selectedFilters, onFilterChange]);

  const durationOptions = ["Más de 15 min", "Menos de 15 min"];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-6">
      <h2 className="font-juana text-xl font-bold mb-4">
        Busca tu próxima clase On-Demand:
      </h2>
      
      <div className="border border-gray-300 bg-white rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <input
            type="text"
            placeholder="Busca aqui una clase por nombre"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos"
          />
          <button
            type="button"
            onClick={onReset}
            className="ml-3 rounded-xl bg-white border border-black text-black px-4 py-2 text-sm font-medium cursor-pointer"
          >
            Reiniciar filtros
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <select
            value={selectedFilters.category}
            onChange={(e) => handleInputChange('category', e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos cursor-pointer"
          >
            <option value="">Todas las disciplinas</option>
            {categories?.map((category) => (
              <option key={category._id} value={category._id}>
                {category.name}
              </option>
            ))}
          </select>

          <select
            value={selectedFilters.teacher}
            onChange={(e) => handleInputChange('teacher', e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos cursor-pointer"
          >
            <option value="">Coach</option>
            {teachers?.map((teacher) => (
              <option key={teacher} value={teacher}>
                {teacher}
              </option>
            ))}
          </select>

          <select
            value={selectedFilters.partner}
            onChange={(e) => handleInputChange('partner', e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos cursor-pointer"
          >
            <option value="">Partner</option>
            {partners?.map((partner) => (
              <option key={partner._id} value={partner._id}>
                {partner.name}
              </option>
            ))}
          </select>

          <select
            value={selectedFilters.duration}
            onChange={(e) => handleInputChange('duration', e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos cursor-pointer"
          >
            <option value="">Duración</option>
            {durationOptions.map((duration) => (
              <option key={duration} value={duration}>
                {duration}
              </option>
            ))}
          </select>

          <select
            value={selectedFilters.equipment}
            onChange={(e) => handleInputChange('equipment', e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-holos cursor-pointer"
          >
            <option value="">Implementos</option>
            {equipment?.map((item) => (
              <option key={item._id} value={item._id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Filters;